import { drawerAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);

export const Drawer = defineMultiStyleConfig({
  baseStyle: {
    body: {
      pb: '24px',
    },
    closeButton: {
      top: '16px',
    },
  },
});
